import { useTranslation } from 'react-i18next'

import * as PropTypes from 'prop-types'

import { Dialog, Button, Flex, Heading, Text } from '@buffer-mono/popcorn'

import styles from './DeleteCampaignModal.module.css'

const DeleteCampaignModal = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'deleteCampaign' implicitly has an... Remove this comment to see the full error message
  deleteCampaign,
  // @ts-expect-error TS(7031) FIXME: Binding element 'hideModal' implicitly has an 'any... Remove this comment to see the full error message
  hideModal,
  // @ts-expect-error TS(7031) FIXME: Binding element 'loading' implicitly has an 'any' ... Remove this comment to see the full error message
  loading,
  // @ts-expect-error TS(7031) FIXME: Binding element 'campaign' implicitly has an 'any'... Remove this comment to see the full error message
  campaign,
}) => {
  const { t } = useTranslation()
  const getDeleteText = () => t('campaigns.deleteTagModal.delete')

  const getTitleText = () => t('campaigns.deleteTagModal.title')

  return (
    <Dialog open={true} onOpenChange={() => hideModal()}>
      <Dialog.Content size="medium">
        <Dialog.Body>
          <Dialog.CloseButton />
          <Flex direction="column" gap="md" className={styles.container}>
            <Heading size="medium" className={styles.heading}>
              {`${getTitleText()} "${campaign.name}"?`}
            </Heading>
            <Text weight="medium" color="subtle">
              {t('campaigns.deleteTagModal.boldSubtext')}
            </Text>
            <Text color="subtle">{t('campaigns.deleteTagModal.subtext')}</Text>
            <Flex direction="row" gap="sm" justify="end">
              <Button variant="tertiary" onClick={() => hideModal()}>
                {t('campaigns.deleteCampaignModal.cancel')}
              </Button>
              <Button
                variant="critical"
                onClick={() => deleteCampaign(true)}
                disabled={loading}
              >
                {loading
                  ? t('campaigns.deleteCampaignModal.loading')
                  : getDeleteText()}
              </Button>
            </Flex>
          </Flex>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  )
}

DeleteCampaignModal.propTypes = {
  deleteCampaign: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
}

export default DeleteCampaignModal
